import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/AppLauncher/app-launcher';
export var ApplicationLauncherIcon = function ApplicationLauncherIcon(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement("span", Object.assign({
    className: css(styles.appLauncherMenuItemIcon)
  }, props), children);
};